<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <el-select
          v-model="selectvalue"
          @change="rebuildChart('main')"
          style="width: 21%; margin-left: 0; padding: 0"
        >
          <el-option
            v-for="item in selectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="search"
          placeholder="検索ワードを入力"
          clearable
          style="width: 23%; margin-left: 10px; margin-right: 10px"
          @change="filterEchart()"
        ></el-input>
        <!-- <el-button
          icon="el-icon-sort"
          circle
          size="small"
          @click="sortList()"
        ></el-button> -->
        <span style="padding: 0 5px 0 5px">{{
          this.$root.htmlConst.cons_223_aggregate_period
        }}</span>
        <el-date-picker
            v-model="datePicker"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="〜"
            :picker-options="pickerOptions"
            @change="rebuildChart('main')"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
      </el-row>
      <hr />
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view2"
          :option="option"
          @legendselectchanged="legendselectchanged"
        />
        <!-- <echarts
          :autoresize="true"
          class="chart-view2"
          :option="option"
          @click="onClick"
          @legendselectchanged="legendselectchanged"
        /> -->
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold; margin-right: 10px">{{
              displayTitle
            }}</span>
          </el-row>
          <el-row>
            <el-select
              v-model="selectvalue"
              @change="rebuildChart('popup')"
              style="width: 21%; margin-left: 0; padding: 0"
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="search"
              placeholder="検索ワードを入力"
              clearable
              style="width: 23%; margin-left: 10px; margin-right: 10px"
              @change="filterEchart()"
            ></el-input>
            <!-- <el-button
              icon="el-icon-sort"
              circle
              size="small"
              @click="sortList()"
            ></el-button> -->
            <span style="padding: 0 5px 0 5px">{{
              this.$root.htmlConst.cons_223_aggregate_period
            }}</span>
            <el-date-picker
                v-model="datePicker"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="〜"
                :picker-options="pickerOptions"
                @change="rebuildChart('popup')"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                :clearable="false"
              >
              </el-date-picker>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @legendselectchanged="legendselectchanged"
        />
        <!-- <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @click="onClick"
          @legendselectchanged="legendselectchanged"
        /> -->
      </el-dialog>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
var _ = require("lodash");
export default {
  name: "ChatbotSupportSurveyEvaluateCountChart",
  props: ["title", "displayTitle"],
  data() {
    let _this = this;
    return {
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 30);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datePicker: [this.$root.startDate, this.$root.endDate],
      search: "",
      selectOptions: [
        {
          value: "上位10件",
          label: "上位10件",
        },
        {
          value: "上位20件",
          label: "上位20件",
        },
        {
          value: "上位100件",
          label: "上位100件",
        },
        {
          value: "下位10件",
          label: "下位10件",
        },
        {
          value: "下位20件",
          label: "下位20件",
        },
        {
          value: "下位100件",
          label: "下位100件",
        },
        {
          value: "全件",
          label: "全件",
        },
      ],
      selectvalue: "上位10件",
      data_list: [],
      operatorList: [],
      evaluationConfig: ""
    };
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.datePicker = [startDate, endDate];
      this.rebuildChart("main");
    });
  },
  created() {
    let self = this;
    self.loading = true;

    api
      .getChatbotSupportSurveyEvaluateCount(
        self.datePicker[0],
        self.datePicker[1],
        self.selectvalue,
        self.$root.facetForEchart,
        self.$root.ageForEchart,
        self.$root.sexForEchart
      )
      .then(
        (res) => {
          let data = res.data;
          self.data_list = data.output_list;
          self.operatorList = data.operatorList;
          self.evaluationConfig = data.evaluationConfig;
          let legendData = [];
          let legendSelected = {};
          let seriesData = [];
          if (self.evaluationConfig == "0") {
            legendData = ["無評価", "低評価", "高評価"];
            legendSelected = {
                無評価: true,
                低評価: true,
                高評価: true,
            };
            seriesData = [
              {
                name: "無評価",
                type: "bar",
                stack: "总量",
                barWidth: 40,
                barMaxWidth: 40,
                z: 0,
                data: self.data_list.opCountZeroList.map((v) => v.count),
              },
              {
                name: "低評価",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountOneList.map((v) => v.count),
              },
              {
                name: "高評価",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountTwoList.map((v) => v.count),
              },
            ];
          } else if (self.evaluationConfig == "1") {
            legendData = ["無評価", "☆1", "☆2", "☆3", "☆4", "☆5"];
            legendSelected = {
                無評価: true,
                '☆1': true,
                '☆2': true,
                '☆3': true,
                '☆4': true,
                '☆5': true,
            };
            seriesData = [
              {
                name: "無評価",
                type: "bar",
                stack: "总量",
                barWidth: 40,
                barMaxWidth: 40,
                z: 0,
                data: self.data_list.opCountZeroList.map((v) => v.count),
              },
              {
                name: "☆1",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountOneList.map((v) => v.count),
              },
              {
                name: "☆2",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountTwoList.map((v) => v.count),
              },
              {
                name: "☆3",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountThreeList.map((v) => v.count),
              },
              {
                name: "☆4",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountFourList.map((v) => v.count),
              },
              {
                name: "☆5",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountFiveList.map((v) => v.count),
              },
            ];
          } else if (self.evaluationConfig == "2") {
            legendData = ["無評価", "☆1", "☆2", "☆3", "☆4", "☆5", "☆6", "☆7", "☆8", "☆9", "☆10"];
            legendSelected = {
                無評価: true,
                '☆1': true,
                '☆2': true,
                '☆3': true,
                '☆4': true,
                '☆5': true,
                '☆6': true,
                '☆7': true,
                '☆8': true,
                '☆9': true,
                '☆10': true,
            };
            seriesData = [
              {
                name: "無評価",
                type: "bar",
                stack: "总量",
                barWidth: 40,
                barMaxWidth: 40,
                z: 0,
                data: self.data_list.opCountZeroList.map((v) => v.count),
              },
              {
                name: "☆1",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountOneList.map((v) => v.count),
              },
              {
                name: "☆2",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountTwoList.map((v) => v.count),
              },
              {
                name: "☆3",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountThreeList.map((v) => v.count),
              },
              {
                name: "☆4",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountFourList.map((v) => v.count),
              },
              {
                name: "☆5",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountFiveList.map((v) => v.count),
              },
              {
                name: "☆6",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountSixList.map((v) => v.count),
              },
              {
                name: "☆7",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountSevenList.map((v) => v.count),
              },
              {
                name: "☆8",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountEightList.map((v) => v.count),
              },
              {
                name: "☆9",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountNineList.map((v) => v.count),
              },
              {
                name: "☆10",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.opCountTenList.map((v) => v.count),
              },
            ];
          }
          self.option = {
            color: ["#DDDDDD", "#F56C6C", "#feb7b0", "#beeb9f", "#9be06e", "#67C23A"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              type: 'scroll',
              width: '530px',
              data: legendData,
              selected: legendSelected,
            },
            dataZoom: [
              {
                type: "slider",
                show: true,
                yAxisIndex: [0],
                showDetail: false,
                start: 100,
                end: self.computedPosition(
                  1,
                  self.data_list.opCountZeroList.length
                ),
                maxValueSpan: 5,
                width: 10,
                fillerColor: "#269cdb",
                borderRadius: 5,
                showDataShadow: false,
                realtime: true,
                zoomLock: true,
                filterMode: "filter",
              },
              {
                type: "inside",
                yAxisIndex: 0,
                zoomOnMouseWheel: false,
                moveOnMouseMove: true,
                moveOnMouseWheel: true,
              },
            ],
            grid: {
              top: "8%",
              bottom: "10%",
              left: "5%",
              right: "5%",
            },
            xAxis: {
              type: "value",
              axisLabel: {
                formatter: function (value) {
                  return value;
                },
              },
            },
            yAxis: {
              type: "category",
              axisLabel: {
                inside: true,
                color: "#000055",
                z: 1,
              },
              data: self.operatorList.map((v) => v.operatorName),
            },
            series: seriesData,
          };
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );
  },
  methods: {
    sortList() {
      this.operatorList = _.reverse(this.operatorList);
      this.data_list.opCountZeroList = _.reverse(this.data_list.opCountZeroList);
      this.data_list.opCountOneList = _.reverse(this.data_list.opCountOneList);
      this.data_list.opCountTwoList = _.reverse(this.data_list.opCountTwoList);
      this.data_list.opCountThreeList = _.reverse(this.data_list.opCountThreeList);
      this.data_list.opCountFourList = _.reverse(this.data_list.opCountFourList);
      this.data_list.opCountFiveList = _.reverse(this.data_list.opCountFiveList);
      this.data_list.opCountSixList = _.reverse(this.data_list.opCountSixList);
      this.data_list.opCountSevenList = _.reverse(this.data_list.opCountSevenList);
      this.data_list.opCountEightList = _.reverse(this.data_list.opCountEightList);
      this.data_list.opCountNineList = _.reverse(this.data_list.opCountNineList);
      this.data_list.opCountTenList = _.reverse(this.data_list.opCountTenList);

      let legendData = [];
      let legendSelected = {};
      let seriesData = [];
      if (this.evaluationConfig == "0") {
        legendData = ["無評価", "低評価", "高評価"];
        legendSelected = {
            無評価: true,
            低評価: true,
            高評価: true,
        };
        seriesData = [
          {
            name: "無評価",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.opCountZeroList.map((v) => v.count),
          },
          {
            name: "低評価",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountOneList.map((v) => v.count),
          },
          {
            name: "高評価",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountTwoList.map((v) => v.count),
          },
        ];
      } else if (this.evaluationConfig == "1") {
        legendData = ["無評価", "☆1", "☆2", "☆3", "☆4", "☆5"];
        legendSelected = {
            無評価: true,
            '☆1': true,
            '☆2': true,
            '☆3': true,
            '☆4': true,
            '☆5': true,
        };
        seriesData = [
          {
            name: "無評価",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.opCountZeroList.map((v) => v.count),
          },
          {
            name: "☆1",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountOneList.map((v) => v.count),
          },
          {
            name: "☆2",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountTwoList.map((v) => v.count),
          },
          {
            name: "☆3",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountThreeList.map((v) => v.count),
          },
          {
            name: "☆4",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountFourList.map((v) => v.count),
          },
          {
            name: "☆5",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountFiveList.map((v) => v.count),
          },
        ];
      } else if (this.evaluationConfig == "2") {
        legendData = ["無評価", "☆1", "☆2", "☆3", "☆4", "☆5", "☆6", "☆7", "☆8", "☆9", "☆10"];
        legendSelected = {
            無評価: true,
            '☆1': true,
            '☆2': true,
            '☆3': true,
            '☆4': true,
            '☆5': true,
            '☆6': true,
            '☆7': true,
            '☆8': true,
            '☆9': true,
            '☆10': true,
        };
        seriesData = [
          {
            name: "無評価",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.opCountZeroList.map((v) => v.count),
          },
          {
            name: "☆1",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountOneList.map((v) => v.count),
          },
          {
            name: "☆2",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountTwoList.map((v) => v.count),
          },
          {
            name: "☆3",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountThreeList.map((v) => v.count),
          },
          {
            name: "☆4",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountFourList.map((v) => v.count),
          },
          {
            name: "☆5",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountFiveList.map((v) => v.count),
          },
          {
            name: "☆6",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountSixList.map((v) => v.count),
          },
          {
            name: "☆7",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountSevenList.map((v) => v.count),
          },
          {
            name: "☆8",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountEightList.map((v) => v.count),
          },
          {
            name: "☆9",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountNineList.map((v) => v.count),
          },
          {
            name: "☆10",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountTenList.map((v) => v.count),
          },
        ];
      }
      this.option = {
        color: ["#DDDDDD", "#F56C6C", "#feb7b0", "#beeb9f", "#9be06e", "#67C23A"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          type: 'scroll',
          width: '530px',
          data: legendData,
          selected: legendSelected,
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            yAxisIndex: [0],
            showDetail: false,
            start: 100,
            end: this.computedPosition(1, this.data_list.opCountZeroList.length),
            maxValueSpan: 5,
            width: 10,
            fillerColor: "#269cdb",
            borderRadius: 5,
            showDataShadow: false,
            realtime: true,
            zoomLock: true,
            filterMode: "filter",
          },
          {
            type: "inside",
            yAxisIndex: 0,
            zoomOnMouseWheel: false,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        grid: {
          top: "8%",
          bottom: "10%",
          left: "5%",
          right: "5%",
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value;
            },
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            inside: true,
            color: "#000055",
            z: 1,
          },
          data: this.operatorList.map((v) => v.operatorName),
        },
        series: seriesData,
      };
    },
    computedPosition(length, xArraylength) {
      if (xArraylength > 5) {
        return 104 - (5 / xArraylength) * 100;
      } else {
        return 0;
      }
    },
    filterEchart() {
      let legendData = [];
      let legendSelected = {};
      let seriesData = [];
      if (this.evaluationConfig == "0") {
        legendData = ["無評価", "低評価", "高評価"];
        legendSelected = {
            無評価: true,
            低評価: true,
            高評価: true,
        };
        seriesData = [
          {
            name: "無評価",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.opCountZeroList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "低評価",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountOneList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "高評価",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountTwoList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
        ];
      } else if (this.evaluationConfig == "1") {
        legendData = ["無評価", "☆1", "☆2", "☆3", "☆4", "☆5"];
        legendSelected = {
            無評価: true,
            '☆1': true,
            '☆2': true,
            '☆3': true,
            '☆4': true,
            '☆5': true,
        };
        seriesData = [
          {
            name: "無評価",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.opCountZeroList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆1",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountOneList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆2",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountTwoList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆3",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountThreeList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆4",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountFourList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆5",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountFiveList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
        ];
      } else if (this.evaluationConfig == "2") {
        legendData = ["無評価", "☆1", "☆2", "☆3", "☆4", "☆5", "☆6", "☆7", "☆8", "☆9", "☆10"];
        legendSelected = {
            無評価: true,
            '☆1': true,
            '☆2': true,
            '☆3': true,
            '☆4': true,
            '☆5': true,
            '☆6': true,
            '☆7': true,
            '☆8': true,
            '☆9': true,
            '☆10': true,
        };
        seriesData = [
          {
            name: "無評価",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.opCountZeroList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆1",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountOneList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆2",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountTwoList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆3",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountThreeList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆4",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountFourList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆5",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountFiveList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆6",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountSixList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆7",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountSevenList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆8",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountEightList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆9",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountNineList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "☆10",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.opCountTenList
              .filter(
                (data) =>
                  !this.search ||
                  data.operatorName
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
        ];
      }
      this.option = {
        color: ["#DDDDDD", "#F56C6C", "#feb7b0", "#beeb9f", "#9be06e", "#67C23A"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          type: 'scroll',
          width: '530px',
          data: legendData,
          selected: legendSelected,
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            yAxisIndex: [0],
            showDetail: false,
            start: 100,
            end: this.computedPosition(1, this.data_list.opCountZeroList.length),
            maxValueSpan: 5,
            width: 10,
            fillerColor: "#269cdb",
            borderRadius: 5,
            showDataShadow: false,
            realtime: true,
            zoomLock: true,
            filterMode: "filter",
          },
          {
            type: "inside",
            yAxisIndex: 0,
            zoomOnMouseWheel: false,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        grid: {
          top: "8%",
          bottom: "10%",
          left: "5%",
          right: "5%",
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value;
            },
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            inside: true,
            color: "#000055",
            z: 1,
          },
          data: this.operatorList
            .map((v) => v.operatorName)
            .filter(
              (data) =>
                !this.search ||
                data.toLowerCase().includes(this.search.toLowerCase())
            ),
        },
        series: seriesData,
      };
    },
    showPopUp() {
      this.popUpDisplay = true;
    },
    rebuildChart(value) {
      this.search = "";
      let self = this;
      if (value == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }

      api
        .getChatbotSupportSurveyEvaluateCount(
          self.datePicker[0],
          self.datePicker[1],
          self.selectvalue,
          self.$root.facetForEchart,
          self.$root.ageForEchart,
          self.$root.sexForEchart
        )
        .then(
          (res) => {
            let data = res.data;
            self.data_list = data.output_list;
            self.operatorList = data.operatorList;
            self.evaluationConfig = data.evaluationConfig;
            let legendData = [];
            let legendSelected = {};
            let seriesData = [];
            if (self.evaluationConfig == "0") {
              legendData = ["無評価", "低評価", "高評価"];
              legendSelected = {
                  無評価: true,
                  低評価: true,
                  高評価: true,
              };
              seriesData = [
                {
                  name: "無評価",
                  type: "bar",
                  stack: "总量",
                  barWidth: 40,
                  barMaxWidth: 40,
                  z: 0,
                  data: self.data_list.opCountZeroList.map((v) => v.count),
                },
                {
                  name: "低評価",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountOneList.map((v) => v.count),
                },
                {
                  name: "高評価",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountTwoList.map((v) => v.count),
                },
              ];
            } else if (self.evaluationConfig == "1") {
              legendData = ["無評価", "☆1", "☆2", "☆3", "☆4", "☆5"];
              legendSelected = {
                  無評価: true,
                  '☆1': true,
                  '☆2': true,
                  '☆3': true,
                  '☆4': true,
                  '☆5': true,
              };
              seriesData = [
                {
                  name: "無評価",
                  type: "bar",
                  stack: "总量",
                  barWidth: 40,
                  barMaxWidth: 40,
                  z: 0,
                  data: self.data_list.opCountZeroList.map((v) => v.count),
                },
                {
                  name: "☆1",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountOneList.map((v) => v.count),
                },
                {
                  name: "☆2",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountTwoList.map((v) => v.count),
                },
                {
                  name: "☆3",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountThreeList.map((v) => v.count),
                },
                {
                  name: "☆4",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountFourList.map((v) => v.count),
                },
                {
                  name: "☆5",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountFiveList.map((v) => v.count),
                },
              ];
            } else if (self.evaluationConfig == "2") {
              legendData = ["無評価", "☆1", "☆2", "☆3", "☆4", "☆5", "☆6", "☆7", "☆8", "☆9", "☆10"];
              legendSelected = {
                  無評価: true,
                  '☆1': true,
                  '☆2': true,
                  '☆3': true,
                  '☆4': true,
                  '☆5': true,
                  '☆6': true,
                  '☆7': true,
                  '☆8': true,
                  '☆9': true,
                  '☆10': true,
              };
              seriesData = [
                {
                  name: "無評価",
                  type: "bar",
                  stack: "总量",
                  barWidth: 40,
                  barMaxWidth: 40,
                  z: 0,
                  data: self.data_list.opCountZeroList.map((v) => v.count),
                },
                {
                  name: "☆1",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountOneList.map((v) => v.count),
                },
                {
                  name: "☆2",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountTwoList.map((v) => v.count),
                },
                {
                  name: "☆3",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountThreeList.map((v) => v.count),
                },
                {
                  name: "☆4",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountFourList.map((v) => v.count),
                },
                {
                  name: "☆5",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountFiveList.map((v) => v.count),
                },
                {
                  name: "☆6",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountSixList.map((v) => v.count),
                },
                {
                  name: "☆7",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountSevenList.map((v) => v.count),
                },
                {
                  name: "☆8",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountEightList.map((v) => v.count),
                },
                {
                  name: "☆9",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountNineList.map((v) => v.count),
                },
                {
                  name: "☆10",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.opCountTenList.map((v) => v.count),
                },
              ];
            }

            self.option = {
              color: ["#DDDDDD", "#F56C6C", "#feb7b0", "#beeb9f", "#9be06e", "#67C23A"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              legend: {
                type: 'scroll',
                width: '530px',
                data: legendData,
                selected: legendSelected,
              },
              dataZoom: [
                {
                  type: "slider",
                  show: true,
                  yAxisIndex: [0],
                  showDetail: false,
                  start: 100,
                  end: self.computedPosition(
                    1,
                    self.data_list.opCountZeroList.length
                  ),
                  maxValueSpan: 5,
                  width: 10,
                  fillerColor: "#269cdb",
                  borderRadius: 5,
                  showDataShadow: false,
                  realtime: true,
                  zoomLock: true,
                  filterMode: "filter",
                },
                {
                  type: "inside",
                  yAxisIndex: 0,
                  zoomOnMouseWheel: false,
                  moveOnMouseMove: true,
                  moveOnMouseWheel: true,
                },
              ],
              grid: {
                top: "8%",
                bottom: "10%",
                left: "5%",
                right: "5%",
              },
              xAxis: {
                type: "value",
                axisLabel: {
                  formatter: function (value) {
                    return value;
                  },
                },
              },
              yAxis: {
                type: "category",
                axisLabel: {
                  inside: true,
                  color: "#000055",
                  z: 1,
                },
                data: self.operatorList.map((v) => v.operatorName),
              },
              series: seriesData,
            };
            if (value == "main") {
              self.loading = false;
            } else {
              self.popupLoading = false;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    },
    legendselectchanged(params) {
      this.search = "";
      if (this.evaluationConfig == "0") {
        if (params.selected["無評価"] == true) {
          this.option.legend.selected["無評価"] = true;
          this.option.series[0].data = this.data_list.opCountZeroList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["無評価"] = false;
          this.option.series[0].data = [];
        }

        if (params.selected["低評価"] == true) {
          this.option.legend.selected["低評価"] = true;
          this.option.series[1].data = this.data_list.opCountOneList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["低評価"] = false;
          this.option.series[1].data = [];
        }

        if (params.selected["高評価"] == true) {
          this.option.legend.selected["高評価"] = true;
          this.option.series[2].data = this.data_list.opCountTwoList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["高評価"] = false;
          this.option.series[2].data = [];
        }
      } else if (this.evaluationConfig == "1") {
        if (params.selected["無評価"] == true) {
          this.option.legend.selected["無評価"] = true;
          this.option.series[0].data = this.data_list.opCountZeroList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["無評価"] = false;
          this.option.series[0].data = [];
        }

        if (params.selected["☆1"] == true) {
          this.option.legend.selected["☆1"] = true;
          this.option.series[1].data = this.data_list.opCountOneList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆1"] = false;
          this.option.series[1].data = [];
        }

        if (params.selected["☆2"] == true) {
          this.option.legend.selected["☆2"] = true;
          this.option.series[2].data = this.data_list.opCountTwoList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆2"] = false;
          this.option.series[2].data = [];
        }

        if (params.selected["☆3"] == true) {
          this.option.legend.selected["☆3"] = true;
          this.option.series[3].data = this.data_list.opCountThreeList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆3"] = false;
          this.option.series[3].data = [];
        }

        if (params.selected["☆4"] == true) {
          this.option.legend.selected["☆4"] = true;
          this.option.series[4].data = this.data_list.opCountFourList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆4"] = false;
          this.option.series[4].data = [];
        }

        if (params.selected["☆5"] == true) {
          this.option.legend.selected["☆5"] = true;
          this.option.series[5].data = this.data_list.opCountFiveList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆5"] = false;
          this.option.series[5].data = [];
        }

      } else if (this.evaluationConfig == "2") {
        if (params.selected["無評価"] == true) {
          this.option.legend.selected["無評価"] = true;
          this.option.series[0].data = this.data_list.opCountZeroList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["無評価"] = false;
          this.option.series[0].data = [];
        }

        if (params.selected["☆1"] == true) {
          this.option.legend.selected["☆1"] = true;
          this.option.series[1].data = this.data_list.opCountOneList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆1"] = false;
          this.option.series[1].data = [];
        }

        if (params.selected["☆2"] == true) {
          this.option.legend.selected["☆2"] = true;
          this.option.series[2].data = this.data_list.opCountTwoList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆2"] = false;
          this.option.series[2].data = [];
        }

        if (params.selected["☆3"] == true) {
          this.option.legend.selected["☆3"] = true;
          this.option.series[3].data = this.data_list.opCountThreeList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆3"] = false;
          this.option.series[3].data = [];
        }

        if (params.selected["☆4"] == true) {
          this.option.legend.selected["☆4"] = true;
          this.option.series[4].data = this.data_list.opCountFourList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆4"] = false;
          this.option.series[4].data = [];
        }

        if (params.selected["☆5"] == true) {
          this.option.legend.selected["☆5"] = true;
          this.option.series[5].data = this.data_list.opCountFiveList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆5"] = false;
          this.option.series[5].data = [];
        }

        if (params.selected["☆6"] == true) {
          this.option.legend.selected["☆6"] = true;
          this.option.series[6].data = this.data_list.opCountSixList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆6"] = false;
          this.option.series[6].data = [];
        }

        if (params.selected["☆7"] == true) {
          this.option.legend.selected["☆7"] = true;
          this.option.series[7].data = this.data_list.opCountSevenList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆7"] = false;
          this.option.series[7].data = [];
        }

        if (params.selected["☆8"] == true) {
          this.option.legend.selected["☆8"] = true;
          this.option.series[8].data = this.data_list.opCountEightList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆8"] = false;
          this.option.series[8].data = [];
        }

        if (params.selected["☆9"] == true) {
          this.option.legend.selected["☆9"] = true;
          this.option.series[9].data = this.data_list.opCountNineList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆9"] = false;
          this.option.series[9].data = [];
        }

        if (params.selected["☆10"] == true) {
          this.option.legend.selected["☆10"] = true;
          this.option.series[10].data = this.data_list.opCountTenList.map(
            (v) => v.count
          );
        } else {
          this.option.legend.selected["☆10"] = false;
          this.option.series[10].data = [];
        }
      }
      this.option.yAxis.data = this.operatorList.map((v) => v.operatorName);

      // if (
      //   params.selected["NGワード"] == true &&
      //   params.selected["NGマナー"] == true
      // ) {
      //   this.option.legend.selected["NGワード"] = true;
      //   this.option.legend.selected["NGマナー"] = true;
      //   this.option.series[0].data = this.data_list.ngWordsList.map(
      //     (v) => v.count
      //   );
      //   this.option.series[1].data = this.data_list.ngMannerList.map(
      //     (v) => v.count
      //   );
      //   this.option.yAxis.data = this.operatorList.map((v) => v.operatorName);
      // } else if (
      //   params.selected["NGワード"] == false &&
      //   params.selected["NGマナー"] == true
      // ) {
      //   this.option.legend.selected["NGワード"] = false;
      //   this.option.legend.selected["NGマナー"] = true;
      //   this.option.series[0].data = [];
      //   this.option.series[1].data = this.data_list.ngMannerList
      //     .map((v) => v.count)
      //     .sort(function (a, b) {
      //       return a - b;
      //     });
      //   let ngMannerList = JSON.parse(
      //     JSON.stringify(this.data_list.ngMannerList)
      //   );
      //   this.option.yAxis.data = [];
      //   for (let count of this.option.series[1].data) {
      //     for (let [index, ngmanner] of ngMannerList.entries()) {
      //       if (count == ngmanner.count) {
      //         this.option.yAxis.data.push(ngmanner.operatorName);
      //         ngMannerList.splice(index, 1);
      //         break;
      //       }
      //     }
      //   }
      // } else if (
      //   params.selected["NGワード"] == true &&
      //   params.selected["NGマナー"] == false
      // ) {
      //   this.option.legend.selected["NGワード"] = true;
      //   this.option.legend.selected["NGマナー"] = false;
      //   this.option.series[1].data = [];
      //   this.option.series[0].data = this.data_list.ngWordsList
      //     .map((v) => v.count)
      //     .sort(function (a, b) {
      //       return a - b;
      //     });
      //   let ngWordsList = JSON.parse(
      //     JSON.stringify(this.data_list.ngWordsList)
      //   );
      //   this.option.yAxis.data = [];
      //   for (let count of this.option.series[0].data) {
      //     for (let [index, ngword] of ngWordsList.entries()) {
      //       if (count == ngword.count) {
      //         this.option.yAxis.data.push(ngword.operatorName);
      //         ngWordsList.splice(index, 1);
      //         break;
      //       }
      //     }
      //   }
      // } else {
      //   this.option.legend.selected["NGワード"] = false;
      //   this.option.legend.selected["NGマナー"] = false;
      //   this.option.series[0].data = [];
      //   this.option.series[1].data = [];
      //   this.option.yAxis.data = this.operatorList.map((v) => v.operatorName);
      // }
    },
    // onClick(params) {
    //   let user_id = _.find(this.operatorList, { operatorName: params.name })
    //     .user_id;
    //   if (params.seriesName == "NGワード") {
    //     window.open(
    //       this.$root.redmineUrl +
    //         "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=assigned_to_id&op%5Bassigned_to_id%5D=%3D&v%5Bassigned_to_id%5D%5B%5D=" +
    //         user_id +
    //         "&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
    //         this.datePicker[0] +
    //         "&v%5Bcreated_on%5D%5B%5D=" +
    //         this.datePicker[1] +
    //         "&f%5B%5D=cf_47&op%5Bcf_47%5D=*&f%5B%5D=cf_85&op%5Bcf_85%5D=%3D&v%5Bcf_85%5D%5B%5D=STAND_MIC_MODE&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
    //     );
    //   } else {
    //     window.open(
    //       this.$root.redmineUrl +
    //         "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=assigned_to_id&op%5Bassigned_to_id%5D=%3D&v%5Bassigned_to_id%5D%5B%5D=" +
    //         user_id +
    //         "&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
    //         this.datePicker[0] +
    //         "&v%5Bcreated_on%5D%5B%5D=" +
    //         this.datePicker[1] +
    //         "&f%5B%5D=cf_46&op%5Bcf_46%5D=*&f%5B%5D=cf_85&op%5Bcf_85%5D=%3D&v%5Bcf_85%5D%5B%5D=STAND_MIC_MODE&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
    //     );
    //   }
    // },
  },
};
</script>
<style>
.el-input__inner {
  height: 35px;
  line-height: 35px;
}
</style>